import React from 'react';

const Resources = () => {
  const cardStyle = {
    backgroundColor: '#ffffff',
    padding: '2rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    transition: 'all 0.3s ease',
    height: '100%'
  };

  const cardHoverStyle = {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '1.5rem',
    marginTop: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          📚 Resources
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '600px', margin: '0 auto'}}>
          Publications, interviews, and resources for solution-focused practitioners and researchers
        </p>
      </div>
      
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Interviews</h2>
        </div>
        <div style={gridStyle}>
          <a 
            href={`${process.env.PUBLIC_URL}/pdfs/I.K.Berg-and-J.Wheeler.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={cardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.target.style, cardHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = cardStyle.boxShadow;
            }}
          >
            <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
              <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#3b82f6'}}>👥</div>
              <h3 style={{color: '#2563eb', marginBottom: '0.5rem', fontSize: '1.3rem', fontWeight: '600'}}>
                Insoo Kim Berg and John Wheeler
              </h3>
            </div>
            <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
              Foundational interview with pioneering figures in solution-focused brief therapy
            </p>
          </a>
          <a 
            href={`${process.env.PUBLIC_URL}/pdfs/EBTAinterviewTheresSteiner0415.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={cardStyle}
            onMouseEnter={(e) => {
              Object.assign(e.target.style, cardHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = cardStyle.boxShadow;
            }}
          >
            <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
              <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#3b82f6'}}>🗣️</div>
              <h3 style={{color: '#2563eb', marginBottom: '0.5rem', fontSize: '1.3rem', fontWeight: '600'}}>
                Therese Steiner and Ursula Buehlmann
              </h3>
            </div>
            <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
              Insights from experienced solution-focused practitioners
            </p>
          </a>
        </div>
      </div>

      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📖</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Theory & Practice Papers</h2>
        </div>
        
        <div style={{marginBottom: '2.5rem'}}>
          <h3 style={{color: '#1e40af', marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>🛠️</span>
            Tools & Techniques
          </h3>
          <div style={gridStyle}>
            <div style={{...cardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}>
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#1e40af'}}>💑</div>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Deck of trump for couples
                </h4>
              </div>
              <p style={{color: '#6b7280', marginBottom: '1.5rem', lineHeight: '1.6'}}>
                Specialized tools for solution-focused couple therapy
              </p>
              <div style={{display: 'flex', gap: '0.75rem', flexWrap: 'wrap'}}>
                <a 
                  href={`${process.env.PUBLIC_URL}/pdfs/Deckcouple.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: '#2563eb', 
                    color: 'white', 
                    padding: '0.6rem 1.2rem', 
                    borderRadius: '6px', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#2563eb'}
                >
                  📄 Deckcouple
                </a>
                <a 
                  href={`${process.env.PUBLIC_URL}/pdfs/DeckcoupleFC.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: '#2563eb', 
                    color: 'white', 
                    padding: '0.6rem 1.2rem', 
                    borderRadius: '6px', 
                    textDecoration: 'none', 
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#2563eb'}
                >
                  📄 DeckcoupleFC
                </a>
              </div>
            </div>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/night-time_tomasz.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#dbeafe';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#f0f9ff';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#1e40af'}}>🌙</div>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Night time Miracle Question from Tomasz Switek – NTMQ
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Innovative approach to the miracle question technique
              </p>
            </a>
          </div>
        </div>

        <div style={{marginBottom: '2.5rem'}}>
          <h3 style={{color: '#059669', marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>🌱</span>
            Therapeutic Approaches
          </h3>
          <div style={gridStyle}>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/simple_therapy.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#dcfce7';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#f0fdf4';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#059669'}}>⚡</div>
                <h4 style={{color: '#166534', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Simple therapy from Plamen Panayotov
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Streamlined approach to solution-focused practice
              </p>
            </a>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/Solution-Focused-inspirations-from-a-garden.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#dcfce7';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#f0fdf4';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#059669'}}>🌻</div>
                <h4 style={{color: '#166534', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Solution Focused inspirations from a garden by John Wheeler
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Creative metaphors and insights for solution-focused work
              </p>
            </a>
          </div>
        </div>

        <div style={{marginBottom: '2.5rem'}}>
          <h3 style={{color: '#d97706', marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>👨‍🏫</span>
            Supervision & Training
          </h3>
          <div style={gridStyle}>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/Super-What.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#fefce8', border: '1px solid #fde047'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#fef3c7';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#fefce8';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#d97706'}}>🤔</div>
                <h4 style={{color: '#a16207', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Some reflections from Anne-Marie Wulf around supervision- Super-What!
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Insights on solution-focused supervision practices
              </p>
            </a>
          </div>
        </div>

        <div style={{marginBottom: '2.5rem'}}>
          <h3 style={{color: '#7c3aed', marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>🔬</span>
            Research & Theory
          </h3>
          <div style={gridStyle}>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/international_peter.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#fdf4ff', border: '1px solid #e9d5ff'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#f3e8ff';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#fdf4ff';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#7c3aed'}}>🌍</div>
                <h4 style={{color: '#7c2d12', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Short paper from Peter Sundman around EBTA stuff – international_peter
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                International perspectives on EBTA and solution-focused practice
              </p>
            </a>
          </div>
        </div>

        <div style={{marginBottom: '2.5rem'}}>
          <h3 style={{color: '#dc2626', marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>✍️</span>
            Papers from Mark Bayebach
          </h3>
          <div style={gridStyle}>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/Post-Deconstructing_bayebach.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#fef2f2', border: '1px solid #fecaca'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#fee2e2';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#fef2f2';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#dc2626'}}>🔍</div>
                <h4 style={{color: '#dc2626', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Post Deconstructing Beyebach
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Deconstructive approaches in solution-focused therapy
              </p>
            </a>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/Post-Competitive-symmetry.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#fef2f2', border: '1px solid #fecaca'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#fee2e2';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#fef2f2';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#dc2626'}}>⚖️</div>
                <h4 style={{color: '#dc2626', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Post Competitive symmetry
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Understanding competitive dynamics in therapeutic relationships
              </p>
            </a>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/Post-attributional-processes.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#fef2f2', border: '1px solid #fecaca'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#fee2e2';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#fef2f2';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#dc2626'}}>🧠</div>
                <h4 style={{color: '#dc2626', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Post attributional processes
                </h4>
              </div>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Exploring attribution theory in solution-focused contexts
              </p>
            </a>
          </div>
        </div>

        <div style={{marginBottom: '2.5rem'}}>
          <h3 style={{color: '#1e40af', marginBottom: '1.5rem', fontSize: '1.4rem', fontWeight: '600', display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '0.5rem'}}>🤝</span>
            Collaborative Works
          </h3>
          <div style={gridStyle}>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/the_difficulties_and_benefits_of_being_a_simple_therapist.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#dbeafe';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#f0f9ff';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#1e40af'}}>📝</div>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  The Difficulties and Benefits of Being a Simple Therapist
                </h4>
              </div>
              <p style={{color: '#6b7280', marginBottom: '0.75rem', fontSize: '0.9rem', fontStyle: 'italic'}}>
                by Plamen Panayotov, Alasdair Macdonald, Boyan Strahilov
              </p>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Exploring the challenges and advantages of simplified therapeutic approaches
              </p>
            </a>
            <a 
              href={`${process.env.PUBLIC_URL}/pdfs/Why-is-the-agency-Oden-successful.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              style={{...cardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}
              onMouseEnter={(e) => {
                Object.assign(e.target.style, cardHoverStyle);
                e.target.style.backgroundColor = '#dbeafe';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = cardStyle.boxShadow;
                e.target.style.backgroundColor = '#f0f9ff';
              }}
            >
              <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1rem'}}>
                <div style={{fontSize: '1.5rem', marginRight: '1rem', color: '#1e40af'}}>🏢</div>
                <h4 style={{color: '#1e40af', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: '600'}}>
                  Why is the agency Oden successful
                </h4>
              </div>
              <p style={{color: '#6b7280', marginBottom: '0.75rem', fontSize: '0.9rem', fontStyle: 'italic'}}>
                Paper by Swedish professionals
              </p>
              <p style={{color: '#6b7280', margin: 0, lineHeight: '1.6'}}>
                Case study of successful implementation of solution-focused approaches in organizational settings
              </p>
            </a>
          </div>
        </div>
      </div>

      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🔗</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Additional Resources</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem'}}>
          For more resources, publications, and links to related organizations, please contact EBTA or visit our research database.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <a 
            href="/sf-research" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>🔬</span>
            Browse SF Research Database
          </a>
          <a 
            href="/research/definition" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📚</span>
            View Definition & Theory
          </a>
        </div>
      </div>
    </div>
  );
};

export default Resources;
